import { observer } from "mobx-react";
import { useStore } from "../../../app/data/root.store";
import { VaultEmptyStateIcon } from "../../assets/icons"
import { VaultEmptyStateButton, VaultEmptyStateHeader, VaultEmptyStateTitleText, VaultEmptyStateWrapper, VaultIconWrapper } from "./VaultEmptyState.style"

export const VaultEmptyState = observer(({ isMobile }) => {
    const { vaultStore } = useStore();

    const onClickClearFilters = () => vaultStore.resetAndRefetchFiles();

    return (
        <VaultEmptyStateWrapper isMobile={isMobile}>
            <VaultEmptyStateHeader />
            <VaultIconWrapper>
                <VaultEmptyStateIcon />
                <VaultEmptyStateTitleText>No Results Found</VaultEmptyStateTitleText>
                <div>We could not find any file that matches your criteria</div>
            </VaultIconWrapper>
            {vaultStore.hasActiveFilters ? <VaultEmptyStateButton onClick={onClickClearFilters}>Clear filters</VaultEmptyStateButton> : null}
        </VaultEmptyStateWrapper>
    )
})